import axiosInstance from '../services/axiosConfig';
import { API_PATHS } from './config';

export async function submitFeedback(data) {
  return axiosInstance.post(`${API_PATHS.BASE_API_URL}/feedback/public`, data);
}

export async function getFeedbackRewards(userId, email) {
  return axiosInstance.get(`${API_PATHS.BASE_API_URL}/feedback/public/rewards`, {
    params: { user_id: userId, email },
  });
}

export default { submitFeedback, getFeedbackRewards };
